<label
    [attr.data-uitype]="'control-label'"
    [id]="id()"
    [attr.data-testId]="id()"
    [attr.data-styleTarget]="id() + '-label'"
    class="iq-md"
    [datiqTemplateMd]="label()"
>
</label>
